import { Injectable } from '@angular/core';
import { Domain, Label, LanguageService } from '@services/public';
import { ChartConfiguration } from 'chart.js';
import { skillUID } from 'jakapa-utilities-lite';

export interface LeaderReportAPIResponseSelfVsPeerBySkill {
	skillUID: skillUID;
	self: number;
	peer: number;
}

@Injectable({
	providedIn: 'root',
})
export class LeaderReportSelfVsPeerBySkillService {
	// Page langauge.
	labels: { [key in Label]?: string } = {
		[Label.PEER]: '',
		[Label.SELF]: '',
		[Label.SKILL_LEVEL]: '',
	};

	constructor(private _languageSvc: LanguageService) {
		// Get page language.
		this._languageSvc.getLabels(this.labels);
	}

	generateReport(
		data: Array<LeaderReportAPIResponseSelfVsPeerBySkill>,
		domain: Domain,
	): ChartConfiguration {
		const labels: Array<string> = [];
		const selfData: Array<number> = [];
		const peerData: Array<number> = [];

		for (const skill of Object.values(domain.skills)) {
			const scores = data.find((data) => data.skillUID === skill.uid);
			labels.push(skill.name);
			selfData.push(scores?.self || null);
			peerData.push(scores?.peer || null);
		}

		return {
			type: 'bar',
			data: {
				labels,
				datasets: [
					{
						label: this.labels[Label.SELF],
						data: selfData,
						borderRadius: 5,
						backgroundColor: '#3CE986',
					},
					{
						label: this.labels[Label.PEER],
						data: peerData,
						borderRadius: 5,
						backgroundColor: '#74A2FF',
					},
				],
			},
			options: {
				plugins: {
					legend: {
						display: true,
						position: 'top',
						align: 'end',
						labels: {
							useBorderRadius: true,
							borderRadius: 5.5,
							boxWidth: 10,
							boxHeight: 10,
						},
					},
				},
				responsive: true,
				maintainAspectRatio: false,
				indexAxis: 'y',
				scales: {
					y: {
						grid: {
							display: false,
						},
					},
					x: {
						min: 0,
						max: 5,
						ticks: {
							stepSize: 0.5,
						},
						title: {
							display: true,
							text: this.labels[Label.SKILL_LEVEL],
							color: '#757575',
						},
					},
				},
			},
		};
	}
}
